module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f60e.5f80f04e.svg";